<div class='row'>
    <div *ngFor="let reporte of Reportes" class="col-3">
        <div class="card" style="border: 1px solid lightgray;">
            <div class="card-header">
                <h5 class="card-title">
                    {{reporte.SYS44DES}}
                </h5>     
            </div>
            <div class="card-body text-end pb-2">
                <button type="button" class="btn btn-info btn-sm" (click)="ImprimirReporte(reporte.SYS44COD)">
                    Ver Reporte
                </button>
            </div>
        </div>
    </div>
</div>